import { z } from 'zod'
import {
  EmailAddressSchema,
  OptionalNonEmptyStringSchema,
  USPhoneNumberSchema,
  WebsiteUrlSchema,
} from './property.models.ts'
import {
  AgencyProfileIdSchema,
  FileIdSchema,
  TeamIdSchema,
} from './unique-id.models.ts'

/**
 * AgencyProfileDomainSelectModel
 */
export const AgencyProfileDomainSelectModelSchema = z.object({
  agencyProfileId: AgencyProfileIdSchema,
  teamId: TeamIdSchema,
  overview: OptionalNonEmptyStringSchema(4096),
  emailAddresses: EmailAddressSchema.array().nonempty(),
  websiteUrls: WebsiteUrlSchema.array().nonempty().optional(),
  phoneNumbers: USPhoneNumberSchema.array().nonempty().optional(),
  logoFileId: FileIdSchema.optional(),
})

export type AgencyProfileDomainSelectModel = z.infer<
  typeof AgencyProfileDomainSelectModelSchema
>

/**
 * AgencyProfileDomainInsertModel
 */
export const AgencyProfileDomainUpsertModelSchema =
  AgencyProfileDomainSelectModelSchema.omit({
    agencyProfileId: true,
  })

export type AgencyProfileDomainUpsertModel = z.infer<
  typeof AgencyProfileDomainUpsertModelSchema
>
